<template lang="html">
    <div class="">
        <div class="header-desktop d-none d-sm-block">
            <div class="container">
                <img src="/media/header-results.jpg" alt="">
            </div>
        </div>
        <div class="header-mobile text-center d-sm-none pb-5">
            <div class="container">
                <img src="https://www.fotografi-cameramani.ro/layout/standard/images/logos/svg/fotografi-cameramani-fundal-inchis-color.svg" class="logo">
                <div class="title">
                    CONCURSUL ANUAL 2020
                </div>
                a 8-a ediţie a concursului naţional de fotografie şi videografie de nuntă din România
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Header',
    components: {
    },
    props: {
    },
    computed: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>

.header-mobile {
    background: black;
    color: white;

    .title {
        font-weight: bold;
        font-size: 22px;
    }
}

.logo {
    max-width: 200px;
}

</style>
